import React from 'react';
import { PromptConfirmation } from 'ui';

import { PromptProps, withPrompt } from 'app/components';
import { RouteObject } from 'react-router-dom';
import { ImportMappingsTranslation } from 'app/area/import-mappings/constants';

interface LinkCodesPromptProps {
  route: RouteObject;
  shouldPrompt: boolean;
  translation: ImportMappingsTranslation;
}

const ImportMappingsPromptComponent: React.FC<LinkCodesPromptProps & PromptProps> = ({
  shouldDisplayModal, translation, continue: onContinue, cancel
}) => {
  return shouldDisplayModal
    ? <PromptConfirmation
      title={translation.cancel_changes}
      description={translation.are_you_sure}
      continueText={translation.undo_all}
      cancelText={translation.go_back}
      onContinue={onContinue}
      onCancel={cancel} />
    : null;
};

export const ImportMappingsPrompt = withPrompt(ImportMappingsPromptComponent);
